import { render } from "./SecondaryUserForm.vue?vue&type=template&id=0c027ba5"
import script from "./SecondaryUserForm.vue?vue&type=script&lang=js"
export * from "./SecondaryUserForm.vue?vue&type=script&lang=js"

import "./SecondaryUserForm.vue?vue&type=style&index=0&id=0c027ba5&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__